<template>
    <div class="page home-page px-md-8">
        <v-container class="py-3 py-lg-8 px-0">
            <transition name="fade-transition">
                <div v-if="meta">
                    <v-card flat class="bordered px-lg-2 py-1 mb-4 mb-lg-8">
                        <v-card-title class="mb-1 medium-title" style="line-height: 1">
                            <v-icon color="strong-text" class="me-2">mdi-calendar-month</v-icon>
                            <span>تفاصيل الخطة الحالية</span>
                        </v-card-title>
                        <!-- <v-divider class="mx-5 my-1"></v-divider> -->
                        <v-card-text>
                            <v-alert v-if="!!meta.pending_subscription" color="error" type="info" dense text>
                                <span class="font-weight-bold medium-text">لديك اشتراك معلق، برجاء دفع الفاتورة المستحقة في أقرب وقت ليتم تفعيل الاشتراك.</span>
                            </v-alert>
                            <v-list class="pa-0">
                                <v-list-item>
                                    <v-list-item-icon class="me-5 mt-4">
                                        <v-icon v-if="currentPlan === 'free'" size="25" color="muted">mdi-store-outline</v-icon>
                                        <v-icon v-else-if="currentPlan === 'premium'" size="30" color="orange darken-2">mdi-crown-circle-outline</v-icon>
                                        <v-icon v-else-if="currentPlan === 'advanced'" size="30" color="deep-purple">mdi-star-circle-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle class="details-text">الخطة الحالية</v-list-item-subtitle>
                                        <v-list-item-title>
                                            <span v-if="currentPlan === 'free'">الخطة المجانية</span>
                                            <span v-else-if="currentPlan === 'premium'">{{meta.premium_plan_name}}</span>
                                            <span v-else-if="currentPlan === 'advanced'">{{meta.advanced_plan_name}}</span>
                                        </v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider inset class="my-1"></v-divider>
                                <v-list-item>
                                    <v-list-item-icon class="me-5 my-auto">
                                        <v-icon color="primary">mdi-calendar-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-subtitle class="details-text">تاريخ تجديد الاشتراك</v-list-item-subtitle>
                                        <v-list-item-title>{{storeSubscription && storeSubscription.renews_at ? storeSubscription.renews_at : 'لا يوجد'}}</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider inset class="my-1"></v-divider>

                            </v-list>
                            <div class="px-4 mt-4 mb-1">
                                <v-btn v-if="!storeSubscription" :disabled="!!meta.pending_subscription" :dark="!meta.pending_subscription" depressed color="primary" class="px-4" @click="changePlanDialog = true">
                                    <v-icon left>mdi-crown</v-icon>
                                    <span class="me-1">الاشتراك بخطة مدفوعة</span>
                                </v-btn>
                                <v-btn v-else depressed color="error" dark class="px-6" @click="cancelSubscriptionDialog = true">
                                    <v-icon left>mdi-close-circle</v-icon>
                                    <span>إلغاء الاشتراك</span>
                                </v-btn>
                            </div>
                        </v-card-text>

                    </v-card>
                    <v-card flat class="bordered px-lg-2 py-1">
                        
                        <v-card-title class="mb-1 medium-title d-flex align-center" style="line-height: 1">
                            <v-icon color="strong-text" size="20" class="me-2">mdi-file-document-multiple-outline</v-icon>
                            <span>الفواتير</span>
                        </v-card-title>
                        <!-- <v-card-subtitle class="details-text px-5"></v-card-subtitle> -->
                        

                        <v-card-text class="pt-0">
                            <v-simple-table class="e-data-table">
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-right font-weight-medium">
                                                # رقم الفاتورة
                                            </th>
                                            <th class="text-right font-weight-medium">
                                                تاريخ الفاتورة
                                            </th>
                                            <th class="text-center font-weight-medium">
                                                الخطة
                                            </th>
                                            <th class="text-center font-weight-medium">
                                                حالة الفاتورة
                                            </th>
                                            <th class="text-center font-weight-medium">
                                                إجمالي الفاتورة
                                            </th>
                                            <th class="text-left font-weight-medium">
                                                إجراءات
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(bill) in bills" :key="bill.serial" :class="{'red lighten-5': bill.warning}" class="bills-tr">
                                            <td>
                                                <div class="d-flex">
                                                    <span class="me-1">#</span>
                                                    <strong>{{bill.serial}}</strong>
                                                </div>
                                            </td>
                                            <td class="text-right">
                                                {{bill.due_date}}
                                            </td>
                                            <td class="text-center">
                                                <v-chip v-if="bill.plan === 'premium'" outlined label small color="orange darken-1">
                                                    <b>{{meta.premium_plan_name}}</b>
                                                </v-chip>
                                                <v-chip v-else-if="bill.plan === 'advanced'" outlined label small color="deep-purple">
                                                    <b>{{meta.advanced_plan_name}}</b>
                                                </v-chip>
                                            </td>
                                            <td class="text-center">
                                                <v-chip label small :color="bill.status === 'paid' ? 'success' : ( bill.status === 'pending' ? 'amber' : (bill.status === 'unpaid' ? 'text' : 'error'))">
                                                    <span v-if="bill.status === 'paid'">
                                                        تم الدفع
                                                    </span>
                                                    <span v-else-if="bill.status === 'pending'">
                                                        قيد المراجعة
                                                    </span>
                                                    <span v-else-if="bill.status === 'due'">
                                                        مستحقة
                                                    </span>
                                                    <div v-else-if="bill.status === 'overdue'" class="d-flex">
                                                        <v-icon size="18" left class="me-1">mdi-alert-circle-outline</v-icon>
                                                        متأخرة
                                                    </div>
                                                    <span v-else-if="bill.status === 'unpaid'">غير مدفوعة</span>
                                                </v-chip>
                                            </td>
                                            <td class="text-center">
                                                <strong class="text--darken-1" :class="{ 'strong-text--text': !bill.warning, 'error--text': bill.warning}">{{numFormat(bill.total)}} د.ع.</strong>
                                            </td>
                                            <td class="text-left">
                                                <template v-if="!bill.paid && bill.status !== 'pending'">
                                                    <v-btn color="success" depressed class="px-3" @click="openPayBillDialog(bill)"> <!-- billToPay = bill; payConfirmDialog = true; -->
                                                        <v-icon size="18" class="me-1" left>mdi-check-circle-outline</v-icon>
                                                        <span>دفع الفاتورة</span>
                                                    </v-btn>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                            <v-alert v-if="!bills || bills.length === 0" type="info" dense text color="grey" class="my-3">
                                <div class="details-text">لا يوجد فواتير مرتبطة بحسابك</div>
                            </v-alert>

                        </v-card-text>
                    </v-card>
                </div>
            </transition>
        </v-container>
        <div v-if="meta" class="actions">
            <v-dialog v-model="payBillDialog" :max-width="450" :fullscreen="phoneOnly" :fluid="phoneOnly" persistent scrollable overlay-color="#000000" overlay-opacity="0.75">
                <v-card class="recharge-card p-relative">
                    <v-progress-linear v-if="paying" active value="0" indeterminate absolute top color="primary" :height="pcOnly ? 2 : 2" ></v-progress-linear>

                    <v-card-title class="mb-1">
                        <v-icon size="26" color="primary" class="me-2">mdi-cash-check</v-icon>
                        دفع الفاتورة
                    </v-card-title>

                    <v-card-text class="pt-3" style="overflow-x: hidden;">
                        <transition :name="step === 1 ? 'slide-left' : 'slide-right'" mode="out-in">
                            <div v-if="step === 0" key="0">
                                <div class="mb-2 medium-text">
                                    اختر وسيلة الدفع من الوسائل التالية:
                                </div>
                                <v-list class="choose-payment-method mt-4">
                                    <v-list-item v-for="method in paymentMethods" :key="method.value" :class="{'v-list-item--active': paymentMethod === method.value, 'bordered': paymentMethod !== method.value, [`primary--text`]: paymentMethod === method.value}" class="rounded py-1 mb-2 overflow-hidden" v-ripple="phoneOnly" @click="paymentMethod = method.value">
                                        <v-list-item-icon class="me-3">
                                            <!-- <v-radio v-model="paymentMethod" :color="method.color || 'primary'" :value="method.value" /> -->
                                            <v-btn icon :color="paymentMethod === method.value ? 'primary' : 'text'" style="margin-top: -4px">
                                                    <svg v-if="paymentMethod === method.value" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg"><path d="M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2M12,7C9.24,7 7,9.24 7,12C7,14.76 9.24,17 12,17C14.76,17 17,14.76 17,12C17,9.24 14.76,7 12,7Z"></path></svg>
                                                    <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="img" aria-hidden="true" class="v-icon__svg"><path d="M12,20C7.58,20 4,16.42 4,12C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12C20,16.42 16.42,20 12,20M12,2C6.48,2 2,6.48 2,12C2,17.52 6.48,22 12,22C17.52,22 22,17.52 22,12C22,6.48 17.52,2 12,2Z"></path></svg>
                                            </v-btn>
                                        </v-list-item-icon>
                                        <v-list-item-content>
                                            <v-list-item-title class="mb-0" style="line-height: 0!important;">
                                                <img v-if="method.img" :src="method.img" style="max-height: 48px; max-width: 105px; width: auto" />
                                                <v-icon v-else-if="method.icon" size="28" :color="'primary'" class="ms-1">{{method.icon}}</v-icon>
                                            </v-list-item-title>
                                            <!-- <v-list-item-subtitle class="details-text mt-1" style="line-height: 1.4!important">{{method.subtitle}}</v-list-item-subtitle> -->
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>

                                <div class="w-100 mt-4">
                                    <v-btn depressed block color="primary" :disabled="!paymentMethod" @click="step = 1">
                                        <span>الخطوة التالية</span>
                                        <v-icon right style="opacity: 0.75">mdi-chevron-left</v-icon>
                                    </v-btn>
                                </div>
                            </div>
                            <div v-else-if="step === 1" key="1">
                                <div class="payment-gateway-buttons">
                                    <div class="mb-2 text-center">
                                        <img v-if="selectedPaymentMethod.img" :src="selectedPaymentMethod.img" style="max-height: 40px; max-width: 105px; width: auto" />
                                    </div>
                                    <div class="strong-text--text medium-text text-center pa-2 rounded surface2 mb-4">
                                        المبلغ المطلوب: <strong class="primary--text">{{moneyFormat(payBill.total)}} د.ع</strong>
                                    </div>
                                    <div class="black--text text-center mb-4" style="font-size: 15px; line-height: 1.6rem; white-space: pre-line;">{{selectedPaymentMethod.steps}}</div>
                                    <v-divider class="my-5"></v-divider>

                                    <v-form ref="form">
                                        <v-textarea v-model="payMessage" no-resize rows="4" placeholder="أدخل البيانات المطلوبة" outlined :disabled="paying" :rules="[rules.required]"></v-textarea>
                                        <v-file-input v-model="payAttachment" accept="image/*" outlined placeholder="أرفق صورة إثبات الدفع" prepend-icon="" prepend-inner-icon="mdi-attachment" :disabled="paying" :rules="[rules.required]"></v-file-input>
                                    </v-form>

                                    <div class="w-100 mt-5">
                                        <v-btn block :disabled="paying" :loading="paying" depressed color="primary" large @click="submitPayBill">
                                            <v-icon size="24" left>mdi-cash-check</v-icon>
                                            <strong>إتمام الدفع</strong>
                                        </v-btn>
                                    </div>
                                    
                                </div>
                                <div class="w-100 mt-4">
                                    <v-btn color="surface2" block depressed @click="step = 0">
                                        <v-icon left>mdi-arrow-right</v-icon>
                                        <span>العودة للخلف</span>
                                    </v-btn>
                                </div>

                            </div>
                        </transition>

                        <v-btn icon absolute top left :disabled="paying" @click="payBillDialog = false;">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                    </v-card-text>
                    <!-- <v-card-actions class="pt-0 px-6 pb-4">
                        <v-spacer></v-spacer>
                    </v-card-actions> -->
                </v-card>
            </v-dialog>
            <action-dialog v-model="changePlanDialog" max-width="400" vuex-action="changeSubscriptionPlan" title="الاشتراك بخطة مدفوعة" :data="{plan: newPlan}" button-text="تأكيد" success-msg="تم الاشتراك بنجاح" button-color="orange darken-2" @response="changePlanResponse">
                <v-list class="plans-list mb-4">
                    <div class="medium-text muted--text mb-3">اختر الخطة:</div>
                    <v-list-item @click="newPlan = 'premium'" :class="{'v-list-item--active': newPlan === 'premium'}" class="orange--text mb-2">
                        <v-list-item-icon class="me-3">
                            <v-icon color="orange darken-2">mdi-crown</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="strong-text--text">{{meta.premium_plan_name}}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon class="d-flex align-center my-auto">
                            <div v-if="meta.premium_plan_before_discount" class="details-text text--text me-2" style="text-decoration: line-through;">${{numFormat(meta.premium_plan_before_discount)}}</div>
                            <div v-if="meta.premium_plan_price" class="font-weight-bold strong-text--text">${{numFormat(meta.premium_plan_price)}}</div>
                        </v-list-item-icon>
                    </v-list-item>

                    <v-list-item @click="newPlan = 'advanced'" :class="{'v-list-item--active': newPlan === 'advanced'}" class="purple--text mb-2">
                        <v-list-item-icon class="me-3">
                            <v-icon color="deep-purple">mdi-crown</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title class="strong-text--text">{{meta.advanced_plan_name}}</v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-icon class="d-flex align-center my-auto">
                            <div v-if="meta.advanced_plan_before_discount" class="details-text text--text me-2" style="text-decoration: line-through;">${{numFormat(meta.advanced_plan_before_discount)}}</div>
                            <div v-if="meta.advanced_plan_price" class="font-weight-bold strong-text--text">${{numFormat(meta.advanced_plan_price)}}</div>
                        </v-list-item-icon>
                    </v-list-item>
                </v-list>
                <v-alert dense text color="grey darken-1" class="mb-0">
                    <div class="details-text strong-text--text">
                        بعد تأكيد الاشتراك سيُطلب منك دفع فاتورة بقيمة <b class="strong-text--text">{{numFormat(newPlanPrice)}}$</b> بما يُعادل <b class="strong-text--text">{{numFormat(newPlanPrice * meta.usd_iqd_rate)}} د.ع.</b> ليتم تفعيل الاشتراك
                    </div>
                </v-alert>
            </action-dialog>
            <action-dialog v-model="cancelSubscriptionDialog" max-width="400" vuex-action="cancelSubscriptionPlan" title="إلغاء الاشتراك الحالي" :data="{}" button-text="تأكيد" success-msg="تم إلغاء الاشتراك الحالي بنجاح" button-color="error" @response="cancelPlanResponse">
                <v-alert type="error" text color="error" class="mb-0 mt-5">
                    <div class="details-text strong-text--text">
                        إذا قمت بإلغاء الاشتراك ستخسر اﻷيام المتبقية في خطتك الحالية وسيُصبح حسابك على الخطة المجانية!!
                    </div>
                </v-alert>
            </action-dialog>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'


export default {
    name: "Bills",
    components: {
        
    },
    data(){
        return {
            loading: false,


            payBill: null,
            payBillDialog: false,
            paymentMethod: '',
            paying: false,
            step: 0,
            payMessage: '',
            payAttachment: null,
            rules: {
                required: value => !!value || 'لا يمكنك ترك الحقل فارغاً'
            },


            changePlanDialog: false,
            newPlan: 'premium',
            
            cancelSubscriptionDialog: false,

            storeSubscription: null,
            meta: null,
            bills: null,
        }
    },
    computed: {
        ...GlobalComputed,
        currentPlan(){
            return this.storeSubscription && this.storeSubscription.plan ? this.storeSubscription.plan : 'free';
        },
        newPlanPrice(){
            const meta = this.meta;
            const plans = {
                premium: {price: meta.premium_plan_price},
                advanced: {price: meta.advanced_plan_price},
            };
            return plans[this.newPlan].price;
        },
        paymentMethods(){
            let methods = this.meta ? this.meta.ebm_gateway_methods : [];
            return methods.map(method=>{
                return {value: method.name, subtitle: method.text, img: method.logo, steps: method.steps,};
            });
        },
        selectedPaymentMethod(){
            return this.paymentMethods.find(method=>method.value === this.paymentMethod);
        },
        allowBillsPage(){
            return this.platform !== 'ios' || this.appData.ios_show_bpage;
        },
    },
    methods: {
        ...GlobalMethods,
        loadData(){
            if (!this.loading){
                this.loading = true;
                this.$store.dispatch('getBills').then(response=>{
                    const data = response.data;
                    this.storeSubscription = data.current_subscription;
                    this.meta = data.meta;
                    this.bills = data.bills;
                    this.loading = false;
                }).catch(e=>{
                    this.loading = false;
                    this.showMsg('حدثت مشكلة أثناء تحميل البيانات', 'error');
                })
            }
        },

        submitPayBill(){
            if (!this.paying){
                if (this.$refs.form.validate()){
                    this.paying = true;
                    
                    let data = new FormData();
                    data.append('bill_serial', this.payBill.serial);
                    data.append('attachment', this.payAttachment);
                    data.append('payment_method', this.paymentMethod);
                    data.append('message', this.payMessage);

                    this.$store.dispatch('paySubscriptionBill', data).then(response=>{
                        this.paying = false;
                        this.showMsg('شكراً لك، تم الإرسال بنجاح، ستقوم اﻹدارة بتأكيد دفع الفاتورة بعد مراجعة العملية.', 'success')
                        this.payBillDialog = false;

                        window.setTimeout(()=>{
                            this.step = 0;
                            this.payMessage = '';
                            this.payAttachment = null;
                            this.payBill = null;
                        }, 500);

                        this.syncBill(response.data.bill);

                    }).catch(e=>{
                        this.paying = false;
                        this.showMsg('حدثت مشكلة أثناء تنفيذ الإجراء، عاود إرسال الطلب', 'error');

                    })
                }else{
                    this.showMsg('من فضلك املأ الحقول المطلوبة', 'warning');
                }
            }
        },
        changePlanResponse(response){
            const data = response.data;
            if (data.meta){
                Object.assign(this.meta, data.meta);
            }
            if (data.bill){
                this.bills.unshift(data.bill);
            }
        },
        cancelPlanResponse(response){
            const data = response.data;
            if (data.meta){
                Object.assign(this.meta, data.meta);
            }
            if (data.current_subscription || data.current_subscription === null){
                this.storeSubscription = data.current_subscription;
            }
        },
        openPayBillDialog(bill){
            this.payBill = bill;
            this.payBillDialog = true;
        },
        /* payBillAction(bill){
            const data = {
                bill_serial: bill.serial
            };

            this.$store.dispatch('paySubscriptionBill', {data}).then(response=>{
                this.payBillResponse(response);
                this.showMsg('شكراً لك، تم دفع الفاتورة بنجاح', 'success');

            }).catch(e=>{
                this.loading = false;
                this.showMsg('حدثت مشكلة أثناء تنفيذ الإجراء', 'error');
                window.setTimeout(()=>{
                    window.location.reload();
                }, 1000);
            })
        }, */
        payBillResponse(response){
            const data = response.data;
            if (data.meta){
                Object.assign(this.meta, data.meta);
            }
            if (data.current_subscription || data.current_subscription === null){
                this.storeSubscription = data.current_subscription;
            }
            if (data.bill){
                this.syncBill(data.bill);
            }
        },
        syncBill(data){
            this.bills = this.bills.map(item=>{
                if (item.serial === data.serial){
                    Object.assign(item, data);
                }
                return item;
            });
        }
    },
    watch: {
        loading(loading){
            this.setLinearLoading(loading);
        },
        currentPlan(plan){
            if (plan !== this.storeData.subscription){
                this.$store.commit('UPDATE_STORE_DATA', {subscription: plan});
            }
        }
    },
    mounted(){
        if (this.allowBillsPage){
            this.loadData();
        }else{
            this.$router.push('not-found');
        }
    }
};
</script>
<style lang="scss" scoped>
.plans-list{
    .v-list-item{
        &.v-list-item--active{
            border: 1px solid;
            &::before{
                opacity: 0.1;
            }
        }
    }
}
tr.bills-tr{
    td{
        white-space: nowrap;
    }
}
</style>
